import { classNames } from "@ember-decorators/component";
import NotificationOptionsComponent from "select-kit/components/notifications-button";
import { pluginApiIdentifiers, selectKitOptions } from "select-kit/components/select-kit";
const GroupNotificationsButton = dt7948.c(class GroupNotificationsButton extends NotificationOptionsComponent {}, [pluginApiIdentifiers("group-notifications-button"), selectKitOptions({
  i18nPrefix: "groups.notifications"
}), classNames("group-notifications-button")]);
export default GroupNotificationsButton;